/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { useMemo } from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";
import { DropdownButton, NavItem } from "react-bootstrap";
import { IoFolder, IoEllipsisVertical } from "react-icons/io5";
import { orderBy, uniq, map } from "lodash";

import Badge from "../common/Badge";
import Loading from "../common/Loading";

const DepartmentCategoryList = ({
  departmentCategories,
  onClickEdit,
  loading
}) => {
  const columns = useMemo(
    () => [
      {
        Header: "Department",
        accessor: "department",
        id: "department",
        Cell: ({ row }) => row.department?.description
      },
      {
        Header: "Name",
        accessor: "name"
      },
      {
        Header: "Description",
        accessor: "description"
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (
          <Badge className="fixed-width" color={value ? "#7AE0FF" : "red"}>
            {value ? "Active" : "Inactive"}
          </Badge>
        )
      },
      {
        Header: "",
        accessor: "_id",
        maxWidth: 80,
        Aggregated: () => <span />,
        Cell: ({ value }) => (
          <div className="text-center actions">
            <DropdownButton
              title={<IoEllipsisVertical />}
              id="dep-category-dropdown"
            >
              <NavItem onClick={() => onClickEdit(value)}>
                <IoFolder />
                View
              </NavItem>
            </DropdownButton>
          </div>
        )
      }
    ],
    [onClickEdit]
  );

  if (loading) {
    return (
      <div className="vertical-center">
        <Loading />
      </div>
    );
  }

  return (
    <ReactTable
      className="-highlight pd-20"
      data={orderBy(departmentCategories, ["department.description", "name"])}
      showPagination={false}
      columns={columns}
      pageSize={uniq(map(departmentCategories, "name")).length}
      getTdProps={(state, rowInfo, column) => ({
        onClick: () => {
          if (column.id !== "_id" && rowInfo?.original?._id) {
            onClickEdit(rowInfo.original._id);
          }
        }
      })}
    />
  );
};

DepartmentCategoryList.propTypes = {
  departmentCategories: PropTypes.array.isRequired,
  onClickEdit: PropTypes.func.isRequired
};

export default DepartmentCategoryList;
